import HelpDialogLayout, { BodyTypographies, ContentStack, HelpDialogLayoutProps } from "./HelpDialogLayout";

export interface ToiletDialogProps extends HelpDialogLayoutProps {
}
export default function ToiletDialog(props: ToiletDialogProps) {
return (
  <HelpDialogLayout {...props}>
    <ContentStack>
      <BodyTypographies
        contents={[
          "寝ている間にトイレに1回以上起きることを「夜間頻尿」といいます。通常、夜間は抗利尿ホルモンが分泌され、トイレに起きづらくなっていますが、加齢によりこのホルモンの作用が弱まると、夜間頻尿の原因となることがあります。60代で夜1回程度起きることは正常なため、夜間頻尿自体は病気ではありませんが、以下の改善策を試しても効果がない場合やお困りの場合は、泌尿器科を受診することをおすすめします。また糖尿病の方は夜間頻尿が多くなりがちなので、適切に治療しましょう。",
        ]}
      />
      <BodyTypographies
        contents={[
          "①塩分と⽔分の摂取量を少なくする",
          "塩分を多く摂取すると、それを薄めるために体内の水分が血液中に引き込まれ、尿量が増加します。さらに塩分を摂ることで喉が渇き、水分を多く摂ってしまうことが尿量増加を助長します。また、野菜や果物に多く含まれるカリウムは、ナトリウムを尿中に排泄するため、利尿効果を高める働きがあります。そのため、カリウムを多く摂取すると尿量が増える原因になります。夕食時には塩分を控え、寝る3～4時間前からは水分を控えることで、夜間の尿量を減らすことができます。",
        ]}
      />
      <BodyTypographies
        contents={[
          "②アルコール・カフェインを避ける",
          "アルコールやカフェインは利尿作用があり、夜間の尿量を増やす原因となります。そのため、アルコールは適量を守り、就寝前にはコーヒーやカフェインを避けることで、夜間頻尿を軽減することが期待できます。また、これらは睡眠の質にも影響を与えるため、睡眠改善の観点からも避けることが重要です。",
        ]}
      />
    </ContentStack>
  </HelpDialogLayout>
);
}
